import { Fragment } from "react";
import usePage from "../hooks/usePage";
import Menu from "../modules/public/menu/menu";
import Footer from "../modules/public/footer/footer";
import TrackingGrid from "./home/TrackingGrid";

const TrackingPage = () => {
  const { pageSliders, pageImage, pageText } = usePage();

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1">
        {pageSliders}

        <TrackingGrid />

        {pageText}
        {pageImage}
      </main>

      <Footer />
    </Fragment>
  );
};

export default TrackingPage;
